import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Datefield from '@/components/layout/datefield/Datefield.vue'
import UploadFile from '@/components/layout/uploadFile/UploadFile.vue'
import redirecionamento from '@/util/redirecionamentoRotasConteudo'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import mensagens from '@/util/mensagens'
import { BToast } from 'bootstrap-vue'
import fileDownload from 'js-file-download'
import { mapState } from 'vuex'
import util from '@/util'
import documentoUtil from '@/util/documentoUtil'

export default {
  name: 'cadastro-documentos',
  components: {
    cabecalho,
    menuLateral,
    Datefield,
    UploadFile,
    spinnerProcessando,
    'b-toast': BToast
  },

  computed: {
    ...mapState('auth', ['tipoDeAcesso']),

    arquivoNaoLocalizado () {
      return !this.formulario.has_file
    }
  },

  data: () => {
    return {
      tiposDocumentoAceitos: documentoUtil.obterTiposDocumentoAceitos(),
      formulario: {
        id: null,
        category: null,
        title: null,
        summary: null,
        arquivos: [],
        file_file_name: null,
        has_file: false
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      },
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        },
        manipulandoDados: {
          status: false,
          mensagem: ''
        },
        carregandoArquivo: {
          status: false
        }
      }
    }
  },

  mounted () {
    let id = this.$route.params.id
    if (!util.valorEhNulo(id)) {
      this.obterDocumento(id)
    }
  },

  methods: {
    async obterDocumento (id) {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        const resposta = await this.axios.get('/documentos/documento/' + id)
        this.formulario.id = resposta.data.retorno.dados.id
        this.formulario.category = resposta.data.retorno.dados.category
        this.formulario.title = resposta.data.retorno.dados.title
        this.formulario.summary = resposta.data.retorno.dados.summary
        this.formulario.file_original_name = resposta.data.retorno.dados.file_original_name
        this.formulario.has_file = resposta.data.retorno.dados.has_file
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    async salvarRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      this.definirFlagCarregandoArquivo(true)

      let resposta = null

      const formData = this.montarObjetoDeEnvio(this.formulario)

      try {
        resposta = await this.axios.post('/documentos/salvar', formData)

        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }

      this.definirFlagManipulandoDados(false, '')
      this.definirFlagCarregandoArquivo(false)
    },

    montarObjetoDeEnvio (dadosFormulario) {
      const formData = new FormData()
      const campos = Object.entries(dadosFormulario)
      const arquivoAnexado = ['arquivos']

      for (let [chave, valor] of campos) {
        if (!arquivoAnexado.includes(chave) && !util.valorEhNulo(valor)) {
          formData.append(chave, valor)
        }

        if (arquivoAnexado.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave + '[0]', valor, valor.name)
        }
      }
      return formData
    },

    tratarAposSalvarRegistro () {
      if (this.retorno.sucesso) {
        this.$router.push({ name: redirecionamento.obterRota(this.tipoDeAcesso, 'documentos') }).then(() => {
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        })
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
      }
    },

    async baixarDocumento (id, nomeOriginalDoArquivo) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      this.definirFlagCarregandoArquivo(true)
      try {
        const resposta = await this.axios.get('/documentos/download/documento/' + id, {
          responseType: 'blob'
        })
        fileDownload(resposta.data, nomeOriginalDoArquivo)
      } catch (error) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaDownloadDocumento)
      }
      this.definirFlagCarregandoArquivo(false)
      this.definirFlagCarregandoDados(false, '')
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagCarregandoArquivo (status) {
      this.flagsDeControle.carregandoArquivo.status = status
    }
  }
}
